import styled from 'styled-components';
import getColour from '@lendi-ui/commons/colours';
import { link } from '@lendi-ui/typography';

export const OtherApplicantLink = styled.span`
  ${link()};
  color: ${() => getColour('interaction', 'main')};
`;
